module.exports = __webpack_public_path__ + "static/media/parachute-box.b98d5542.svg";